import React from 'react'

import moment from 'moment'
import aSync from 'async'
import _ from 'underscore'
import {parse} from 'csv-parse/browser/esm'
import jschardet from 'jschardet'
import FileSaver from 'file-saver'

import LoginActions from '../../actions/LoginActions.js'
import OrderActions from '../../actions/OrderActions.js'

import {Alert, Button, Colors, Modal, S2, ProgressBar, Link, Row, H5, P, H6, Card} from '../UI/index.js'
import {FormRow, FormStack, Input, Toggle, TextArea, DatePicker, formSpacing, Select, TimePicker, CurrencyInput} from '../UI/forms/index.js'
import NewOrder from '../../../server/functions/orders/NewOrder.js'
import splitAddress from '../../utils/splitAddress.js'
import EditAddress from './EditAddress.js'
import {normalize} from '@utils/normalize.js'
import {prependDefaultOrderNotes, stripDefaultOrderNotes} from '@utils/defaultOrderNotes.js'
import {applyCsvColumns, getOrderCsvColumns} from '@utils/orderCsvColumns.js'
import dbCodes from 'server/dbCodes.js'
import naturalSortBy from '../../utils/naturalSortBy.js'
import t from '../../helpers/Languages.js'

export default class ImportOrders extends React.Component {
    constructor(props) {
        super(props)
        this.initialState = {
            modalIsOpen: false,
            customerId: '',
            contact: '',
            email: '',
            phone: '',
            date: moment().format('YYYY-MM-DD'),
            notes: '',
            startTime: '',
            endTime: '',
            priceTableId: '',
            feeIds: [],
            price: '0,00',
            reference: '',
            pickupOptions: [],
            deliveryOptions: [],
            showAdministration: false,
            showMoreOptions: false,
            nrOfDeliveries: 0,
            autoRetour: false,
            nrOfDaysBeforeRetour: 7,
            retourAddress: {
                startTime: '00:00',
                endTime: '23:59',
                name: '',
                attention: '',
                street: '',
                nr: '',
                addition: '',
                street2: '',
                postalCode: '',
                city: '',
                country: 'NL',
                instructions: '',
                gpsRequired: false,
                signatureRequired: false,
                signatureNeighbors: false,
                statedAddressOnly: false,
                nameRequired: false,
                scanRequired: false,
                imageRequired: false,
                mailboxDelivery: false,
                refrigerated: false,
                minimumAge: false,
                idCheck: false
            },
            orderType: 'delivery',
            ignoreFirstLine: false,
            addColloWithBarcode: false,
            useAddressBook: false,
            columns: [],
            lines: [],
            customerInvalid: false,
            appliedCustomerDefaultOrderNotes: '',
            loading: false,
            progressNow: 0,
            progressMax: null,
            message: '',
            csvColumnsError: '',
            errors: [],
            errorLines: []
        }

        this.state = JSON.parse(JSON.stringify(this.initialState))
    }

    open() {
        const {user, reseller, planningDate} = this.props

        let {customerId, columns, date} = this.state

        if (user.isCustomer) {
            customerId = user.name

            if (user.settings.orders?.csvColumns) {
                columns = [...user.settings.orders.csvColumns]
            }
        }

        this.setState({modalIsOpen: true, customerId, columns, date: reseller?.settings?.orders?.defaultDate === 'selectedDate' && planningDate ? planningDate : date})
    }

    close() {
        this.setState(this.initialState)
    }

    onChangeCustomer(event) {
        let {columns, lines, priceTableId, notes, appliedCustomerDefaultOrderNotes, orderType} = this.state
        const {reseller, customers} = this.props

        const customer = customers[event.target.value]

        if (customer) {
            const contactObject = {name: '', email: '', phone: ''}

            const customerDefaultOrderNotes = customer.settings?.orders?.defaultOrderNotes || ''
            notes = prependDefaultOrderNotes(customerDefaultOrderNotes, stripDefaultOrderNotes(appliedCustomerDefaultOrderNotes, notes || ''))

            // Replace the layout completely so no columns of the previously selected customer remain
            columns = applyCsvColumns(columns, getOrderCsvColumns(reseller, customer._id, orderType), lines.length > 0)

            const customerId = customer._id || ''
            const contact = contactObject.name || ''
            const email = customer.email || ''
            const phone = customer.phone || ''

            if (customer.settings.orders.defaultPriceTable) {
                priceTableId = customer.settings.orders.defaultPriceTable
            }

            this.setState({
                customerId,
                contact,
                email,
                phone,
                priceTableId,
                columns,
                notes,
                appliedCustomerDefaultOrderNotes: customerDefaultOrderNotes,
                customerInvalid: false
            })
        }
    }

    onChangeOrderType(event) {
        const {customerId, columns, lines} = this.state
        const {reseller, customers} = this.props

        const orderType = event.target.value

        // Each order type has its own stored layout per customer; without a customer the layout stays as it is
        if (customers?.[customerId]) {
            this.setState({orderType, columns: applyCsvColumns(columns, getOrderCsvColumns(reseller, customerId, orderType), lines.length > 0)})
        } else {
            this.setState({orderType})
        }
    }

    onChangeContact(event) {
        let {customerId, email, phone} = this.state
        const {customers} = this.props
        const customer = customers[customerId]

        const contact = event.target.value

        const contactObject = _.find(customer?.contacts, {name: contact})

        if (contactObject) {
            email = contactObject.email || ''
            phone = contactObject.phone || ''
        }

        this.setState({contact, email, phone})
    }

    onChangePricetableId(event) {
        const {reseller} = this.props
        const priceTable = _.find(reseller.settings.orders.prices, {id: event.target.value})

        this.setState({priceTableId: priceTable?.id || '', feeIds: [], price: '0,00'})
    }

    onClickOpenFile(event) {
        event.preventDefault()
        document.getElementById('csv').value = null
        document.getElementById('csv').click()
    }

    onLoadFile() {
        const file = document.getElementById('csv').files[0]

        if (file) {
            const reader = new FileReader()
            reader.readAsBinaryString(file)

            reader.onerror = (event) => {
                if (event.target.error.name == 'NotReadableError') {
                    alert('Can\'t read file !')
                }
            }
            reader.onload = (event) => {
                const encoding = jschardet.detect(event.target.result, {minimumThreshold: 0}).encoding
                const reader = new FileReader()
                reader.readAsText(file, encoding)

                reader.onerror = (event) => {
                    if (event.target.error.name == 'NotReadableError') {
                        alert('Can\'t read file !')
                    }
                }
                reader.onload = (event) => {
                    let delimiter = ';'
                    let commaCount = 0
                    let semicolonCount = 0
                    let tabCount = 0

                    event.target.result.split('').slice(0, 500).map((char) => {
                        commaCount += char === ',' ? 1 : 0
                        semicolonCount += char === ';' ? 1 : 0
                        tabCount += char === '\t' ? 1 : 0
                    })

                    if (commaCount > tabCount && commaCount > semicolonCount) {
                        delimiter = ','
                    } else if (tabCount > semicolonCount) {
                        delimiter = '\t'
                    }

                    parse(event.target.result, {delimiter, relax_column_count: true, skip_empty_lines: true, trim: true}, (err, lines) => {
                        if (err) {
                            alert('Geen geldig .csv bestand')
                        } else {
                            const {columns} = this.state

                            let nrOfColumns = 0

                            const nonEmptyLines = []

                            lines.map((line) => {
                                if (line.length > nrOfColumns) {
                                    nrOfColumns = line.length
                                }

                                if (line.join('') !== '') {
                                    nonEmptyLines.push(line)
                                }
                            })

                            const columnDiff = nrOfColumns - columns.length
                            if (columnDiff > 0) {
                                for (let i = 0; i < columnDiff; i++) {
                                    columns.push('')
                                }
                            } else {
                                columns.splice(nrOfColumns)
                            }

                            this.setState({lines: nonEmptyLines, columns, error: ''})
                        }
                    })
                }
            }
        }
    }

    onChangeColumn(index, event) {
        const {columns} = this.state
        columns[index] = event.target.value
        this.setState({columns})
    }

    onClickCreateOrders() {
        const {lines, columns, customerId, contact, email, phone, startTime, endTime, priceTableId, feeIds, price, orderType, ignoreFirstLine, addColloWithBarcode, useAddressBook, pickupOptions: selectedPickupOptions, deliveryOptions: selectedDeliveryOptions, appliedCustomerDefaultOrderNotes} = this.state
        const {reseller, user, customers, addressBook} = this.props
        const customer = customers[customerId]
        const customerFromCSV = columns.indexOf('customer') > -1 || columns.indexOf('debtorCode') > -1

        if (!customer && !customerFromCSV) {
            this.setState({customerInvalid: true})
            this.selectCustomer.focus()
            return
        }

        const findCustomerByDebtorCode = (debtorCode) => _.find(customers, (customer) => customer.debtorCode?.toLowerCase() === debtorCode.toLowerCase())
        const findCustomerByName = (name) => _.find(customers, (customer) => customer.name?.toLowerCase() === name.toLowerCase())

        const resolveLineCustomer = (line) => {
            if (!customerFromCSV) {
                return customer
            }

            let lineCustomer = customer || null

            line.forEach((lineValue, lineIndex) => {
                if (!columns[lineIndex]) {
                    return
                }

                const key = columns[lineIndex].split('.')

                if (key.length !== 1) {
                    return
                }

                const value = String(lineValue ?? '').replace(/"/g, '').trim()

                if (!value) {
                    return
                }

                if (key[0] === 'debtorCode') {
                    lineCustomer = findCustomerByDebtorCode(value) || null
                }

                if (key[0] === 'customer') {
                    lineCustomer = findCustomerByName(value) || null
                }
            })

            return lineCustomer
        }

        const resolveAddressOptions = (lineCustomer) => {
            let pickupOptions = selectedPickupOptions
            let deliveryOptions = selectedDeliveryOptions

            if (pickupOptions.length === 0) {
                pickupOptions = reseller?.settings?.orders?.defaultPickupOptions ?? []

                const customerDefaultPickupOptions = lineCustomer?.settings?.orders?.defaultPickupOptions
                if (Array.isArray(customerDefaultPickupOptions)) {
                    pickupOptions = customerDefaultPickupOptions
                } else if (customerDefaultPickupOptions === 'none') {
                    pickupOptions = []
                }
            }

            if (deliveryOptions.length === 0) {
                deliveryOptions = reseller?.settings?.orders?.defaultDeliveryOptions ?? []

                const customerDefaultDeliveryOptions = lineCustomer?.settings?.orders?.defaultDeliveryOptions
                if (Array.isArray(customerDefaultDeliveryOptions)) {
                    deliveryOptions = customerDefaultDeliveryOptions
                } else if (customerDefaultDeliveryOptions === 'none') {
                    deliveryOptions = []
                }
            }

            return {pickupOptions, deliveryOptions}
        }

        const notesWithoutSelectedCustomerDefaultOrderNotes = stripDefaultOrderNotes(appliedCustomerDefaultOrderNotes, this.state.notes || '')

        const customOptionIds = new Set((reseller?.settings?.orders?.customOptions || []).map((option) => option.id))
        const customOptionNames = new Map((reseller?.settings?.orders?.customOptions || []).map((option) => [option.name.trim(), option.id]))
        const parseCustomOptionIds = (value) => _.uniq(String(value || '').split(/[,;|]/).map((optionId) => optionId.trim()).filter((optionId) => optionId))
        const parseCustomOptionNames = (value) => _.uniq(String(value || '').split(/[,;|]/).map((optionName) => optionName.trim()).filter((optionName) => optionName).map((optionName) => customOptionNames.get(optionName) || ''))

        let success = 0
        const errors = []
        const errorLines = []

        this.setState({loading: true, progressMax: orderType === 'multiOrder' ? 1 : ignoreFirstLine ? lines.length - 1 : lines.length, progressNow: orderType === 'multiOrder' ? 0 : 1})

        if (ignoreFirstLine) {
            lines.shift()
        }

        let order
        // Route the order is put in by the server, for a multi order the first filled route cell counts
        let routeName = ''
        let routeNameIndex = 0
        if (orderType === 'multiOrder') {
            order = NewOrder(reseller, {forcePickupAndDeliverAddresses: true})
        }

        aSync.eachOfSeries(lines, (line, index, next) => {
            if (this.state.stopOperation) return
            if (orderType !== 'multiOrder') {
                order = NewOrder(reseller, {forcePickupAndDeliverAddresses: true})
                routeName = ''
            }

            order.date = this.state.date
            order.customer = customer?._id
            order.contact = contact
            order.email = email
            order.phone = phone

            const lineCustomer = resolveLineCustomer(line)
            const lineCustomerDefaultOrderNotes = lineCustomer?.settings?.orders?.defaultOrderNotes || ''

            order.notes = prependDefaultOrderNotes(lineCustomerDefaultOrderNotes, notesWithoutSelectedCustomerDefaultOrderNotes)

            if (priceTableId) {
                order.priceTableId = priceTableId
                order.feeIds = feeIds
            } else {
                order.price = price
            }

            order.reference = this.state.reference

            order.nrOfDeliveries = this.state.nrOfDeliveries

            order.autoRetour = this.state.autoRetour

            order.allowAddCollo = customer?.settings.orders.allowAddCollo === 'default' ?
                (reseller?.settings.allowAddCollo || '') :
                (customer?.settings.orders.allowAddCollo || '')

            const {pickupOptions, deliveryOptions} = resolveAddressOptions(lineCustomer)

            if (order.autoRetour) {
                order.nrOfDaysBeforeRetour = this.state.nrOfDaysBeforeRetour
                order.retourAddress = this.state.retourAddress
            }

            if (orderType !== 'multiOrder') {
                order.addresses = order.addresses.map((address) => {
                    if (startTime) {
                        address.startTime = startTime
                    }
                    if (endTime) {
                        address.endTime = endTime
                    }

                    address.minimumAge = false
                    Object.keys(dbCodes.pickupAndDeliveryOptions).forEach((option) => {
                        address[option] = false
                    })

                    address.customOptions = []

                    if (address.type === 'pickup') {
                        pickupOptions.forEach((option) => {
                            if (option in dbCodes.pickupAndDeliveryOptions) {
                                address[option] = true
                            } else {
                                address.customOptions.push(option)
                            }
                        })
                    }

                    if (address.type === 'delivery') {
                        deliveryOptions.forEach((option) => {
                            if (option in dbCodes.pickupAndDeliveryOptions) {
                                if (option === 'minimumAge +16') {
                                    address.minimumAge = 16
                                } else if (option === 'minimumAge +18') {
                                    address.minimumAge = 18
                                } else if (option === 'minimumAge +21') {
                                    address.minimumAge = 21
                                } else {
                                    address[option] = true
                                }
                            } else {
                                address.customOptions.push(option)
                            }
                        })
                    }

                    return address
                })
            } else if (index === 0) {
                order.addresses = []
            }

            if (orderType === 'multiOrder') {
                const openingHours = reseller?.settings?.account?.openingHours?.[moment(order.date).format('dddd').toLowerCase()]

                const newAddress = {
                    type: 'delivery',
                    name: '',
                    attention: '',
                    street: '',
                    nr: '',
                    addition: '',
                    street2: '',
                    postalCode: '',
                    city: '',
                    country: 'NL',
                    isBusiness: false,
                    instructions: '',
                    email: '',
                    phone: '',
                    gpsRequired: false,
                    signatureRequired: false,
                    signatureNeighbors: false,
                    statedAddressOnly: false,
                    nameRequired: false,
                    scanRequired: false,
                    imageRequired: false,
                    mailboxDelivery: false,
                    refrigerated: false,
                    minimumAge: false,
                    idCheck: false,
                    startTime: startTime || (openingHours ? openingHours.from : '00:00'),
                    endTime: endTime || (openingHours ? openingHours.till : '23:59')
                }

                if (newAddress.type === 'delivery') {
                    newAddress.customOptions = []

                    deliveryOptions.forEach((option) => {
                        if (option in dbCodes.pickupAndDeliveryOptions) {
                            if (option === 'minimumAge +16') {
                                newAddress.minimumAge = 16
                            } else if (option === 'minimumAge +18') {
                                newAddress.minimumAge = 18
                            } else if (option === 'minimumAge +21') {
                                newAddress.minimumAge = 21
                            } else {
                                newAddress[option] = true
                            }
                        } else {
                            newAddress.customOptions.push(option)
                        }
                    })
                }

                order.addresses.push(newAddress)
            }

            line.map((value, lineIndex) => {
                if (columns[lineIndex]) {
                    const key = columns[lineIndex].split('.')

                    value = value.replace(/"/g, '')

                    if (key[0] === 'addresses' && key[2]) {
                        let addressIndex = parseInt(key[1])

                        if (orderType === 'multiOrder') {
                            addressIndex = order.addresses.length - 1
                        }

                        if (key[2] === 'name') {
                            order.addresses[addressIndex].name = `${order.addresses[addressIndex].name || ''} ${value}`.trim()
                        } else if (key[2] === 'attention') {
                            order.addresses[addressIndex].attention = `${order.addresses[addressIndex].attention || ''} ${value}`.trim()
                        } else if (key[2] === 'street') {
                            order.addresses[addressIndex].street = `${order.addresses[addressIndex].street || ''} ${value}`.trim()
                        } else if (key[2] === 'streetNr') {
                            const address = splitAddress(value)
                            order.addresses[addressIndex].street = address.street
                            order.addresses[addressIndex].nr = address.nr
                            order.addresses[addressIndex].addition = address.addition
                        } else if (key[2] === 'nrAddition') {
                            const address = splitAddress(`straat ${value}`)
                            order.addresses[addressIndex].nr = address.nr
                            order.addresses[addressIndex].addition = address.addition
                        } else if (key[2] === 'street2') {
                            order.addresses[addressIndex].street2 = `${order.addresses[addressIndex].street2 || ''} ${value}`.trim()
                        } else if (key[2] === 'postalCode') {
                            order.addresses[addressIndex].postalCode = `${order.addresses[addressIndex].postalCode || ''} ${value.toUpperCase().replace(/  +/g, ' ')}`.trim()

                            if (/^[0-9]{4}[A-Z]{2}$/.test(order.addresses[addressIndex].postalCode)) {
                                order.addresses[addressIndex].postalCode = `${order.addresses[addressIndex].postalCode.substr(0, 4)} ${order.addresses[addressIndex].postalCode.substr(4, 2)}`
                            }
                        } else if (key[2] === 'country') {
                            order.addresses[addressIndex].country = value.toUpperCase().trim()

                            if (order.addresses[addressIndex].country === 'NLD') {
                                order.addresses[addressIndex].country = 'NL'
                            }
                        } else if (key[2] === 'position') {
                            order.addresses[addressIndex].position = order.addresses[addressIndex].position || {lat: null, lng: null}
                            order.addresses[addressIndex].position.lat = parseFloat(value.split(',')[0])
                            order.addresses[addressIndex].position.lng = parseFloat(value.split(',')[1])
                        } else if (key[2] === 'lat') {
                            order.addresses[addressIndex].position = order.addresses[addressIndex].position || {lat: null, lng: null}
                            order.addresses[addressIndex].position.lat = parseFloat(value)
                        } else if (key[2] === 'lng') {
                            order.addresses[addressIndex].position = order.addresses[addressIndex].position || {lat: null, lng: null}
                            order.addresses[addressIndex].position.lng = parseFloat(value)
                        } else if (key[2] === 'signatureRequired' || key[2] === 'statedAddressOnly' || key[2] === 'mailboxDelivery' || key[2] === 'refrigerated') {
                            order.addresses[addressIndex][key[2]] = !!value
                        } else if (key[2] === 'customOptions') {
                            const parsedCustomOptionIds = parseCustomOptionIds(value)
                            let knownCustomOptionIds = parsedCustomOptionIds.filter((optionId) => customOptionIds.has(optionId))
                            const parsedCustomOptionIdsByName = parseCustomOptionNames(value)
                            const knownCustomOptionIdsByNames = parsedCustomOptionIdsByName.filter((optionId) => customOptionIds.has(optionId))

                            knownCustomOptionIds = _.uniq([...knownCustomOptionIds, ...knownCustomOptionIdsByNames])

                            if (knownCustomOptionIds.length) {
                                order.addresses[addressIndex].customOptions = _.uniq([...(order.addresses[addressIndex].customOptions || []), ...knownCustomOptionIds])
                            }
                        } else if (key[2] === 'instructions') {
                            order.addresses[addressIndex].instructions = `${order.addresses[addressIndex].instructions || ''} ${value}`.trim()
                        } else if (key[2] === 'addressTypePickup' && !!value) {
                            order.addresses[addressIndex].type = 'pickup'
                            order.addresses[addressIndex] = _.omit(order.addresses[addressIndex], ['gpsRequired', 'signatureRequired', 'signatureNeighbors', 'statedAddressOnly', 'nameRequired', 'scanRequired', 'imageRequired', 'mailboxDelivery', 'refrigerated', 'minimumAge', 'idCheck'])

                            if (orderType === 'multiOrder') {
                                pickupOptions.map((option) => {
                                    if (option in dbCodes.pickupAndDeliveryOptions) {
                                        order.addresses[addressIndex][option] = true
                                    } else {
                                        order.addresses[addressIndex].customOptions = order.addresses[addressIndex].customOptions || []
                                        order.addresses[addressIndex].customOptions.push(option)
                                    }
                                })
                            }
                        } else {
                            order.addresses[addressIndex][key[2]] = value.trim()
                        }
                    }

                    if (key.length === 1) {
                        if (key[0] === 'debtorCode') {
                            const csvCustomer = findCustomerByDebtorCode(value.trim())

                            if (csvCustomer) {
                                order.customer = csvCustomer._id
                                order.contact = ''
                            } else {
                                order.customer = ''
                                order.customerId = value
                            }
                        } else if (key[0] === 'customer') {
                            const csvCustomer = findCustomerByName(value.trim())

                            if (csvCustomer) {
                                order.customer = csvCustomer._id
                                order.contact = ''
                            } else {
                                order.customer = ''
                                order.customerId = value
                            }
                        } else if (key[0] === 'date') {
                            if (/^[0-9]{2}-[0-9]{2}-[0-9]{4}$/.test(value)) {
                                order.date = moment(value, 'DD-MM-YYYY').format('YYYY-MM-DD')
                            } else {
                                order.date = value
                            }
                        } else if (key[0] === 'price') {
                            if (value.trim()) {
                                order.price = value.trim()
                            } else if (price) {
                                order.price = price
                            } else {
                                order.price = value.trim() // this will trigger the error "price is not allowed to be empty"
                            }
                        } else if (key[0] === 'reference') {
                            order.reference = `${order.reference || ''} ${value}`.trim()
                        } else if (key[0] === 'nrOfDeliveries') {
                            order.nrOfDeliveries = parseInt(value) || 0
                        } else if (key[0] === 'notes') {
                            order.notes = `${order.notes || ''} ${value}`.trim()
                        } else if (key[0] === 'routeName') {
                            if (!routeName && value.trim()) {
                                routeName = value.trim()
                                routeNameIndex = index
                            }
                        } else {
                            order[key[0]] = value.trim()
                        }
                    }

                    if (key.length === 2 && value) {
                        order[key[0]] = order[key[0]] || {}

                        if (key[1] === 'quantity' || key[1] === 'weight' || key[1] === 'length' || key[1] === 'width' || key[1] === 'height') {
                            order[key[0]][key[1].trim()] = parseInt(value) || 0
                        } else {
                            order[key[0]][key[1]] = value.trim()
                        }
                    }
                }
            })

            if (orderType === 'pickup') {
                order.addresses.splice(1, 1)
            }
            if (orderType === 'delivery') {
                order.addresses.splice(0, 1)
            }

            if (useAddressBook) {
                order.addresses = order.addresses.map((address) => {
                    const bookAddress = addressBook.find((bookAddress) => {
                        return bookAddress.name ?
                            normalize(address.name.trim().toLowerCase()) === normalize(bookAddress.name.trim().toLowerCase()) :
                            (
                                address.street.trim().toLowerCase() === bookAddress.street.trim().toLowerCase() &&
                                address.nr === bookAddress.nr &&
                                address.addition === bookAddress.addition &&
                                address.postalCode === bookAddress.postalCode &&
                                address.city.trim().toLowerCase() === bookAddress.city.trim().toLowerCase() &&
                                address.country === bookAddress.country
                            )
                    })

                    if (bookAddress) {
                        address.street = bookAddress.street
                        address.nr = bookAddress.nr
                        address.addition = bookAddress.addition
                        address.street2 = bookAddress.street2
                        address.postalCode = bookAddress.postalCode
                        address.city = bookAddress.city
                        address.country = bookAddress.country
                        address.isBusiness = !!bookAddress.isBusiness

                        if (bookAddress?.position) {
                            address.position = bookAddress.position
                        }

                        if (!address.instructions && bookAddress?.instructions) {
                            address.instructions = bookAddress.instructions
                        }

                        if (bookAddress?.attachments) {
                            address.attachments = bookAddress.attachments || []
                        }
                    }

                    return address
                })
            }

            if (order.content || order.barcode || addColloWithBarcode || order.colliType) {
                // check if order.barcode and order.colliType contain multiple values separated by comma, semicolon or space
                const barcodes = (order.barcode || '').split(/[,; ]+/).map((barcode) => barcode.trim()).filter((barcode) => barcode !== '')
                const colliTypes = order.colliType ? (order.colliType || '').split(/[,;]+/).map((type) => type.trim()).filter((type) => type !== '') : []
                const resellerColliTypes = reseller.settings.orders.colliTypes || []
                const customerAllowedColliTypes = lineCustomer?.settings.orders?.allowedColliTypes
                const defaultColliTypes = reseller.settings.orders.defaultColliTypes

                const allowedColliTypes = Array.isArray(customerAllowedColliTypes) ?
                    resellerColliTypes.filter((type) => customerAllowedColliTypes.includes(type.id)) :
                    resellerColliTypes.filter((type) => !Array.isArray(defaultColliTypes) || defaultColliTypes.includes(type.id))

                const resolveColliType = (colliType) => {
                    if (!colliType) return ''

                    const foundColliType = allowedColliTypes.find((type) => type.id === colliType || type.name === colliType)

                    return foundColliType ? foundColliType.id : ''
                }

                // Without the toggle a collo without a barcode from the CSV stays without one, 'no barcode' keeps the server from generating one
                const resolveBarcode = (barcode) => (barcode || '').toUpperCase() || (addColloWithBarcode ? '' : 'no barcode')

                const syncedColliLength = Math.max(barcodes.length, colliTypes.length)

                if (syncedColliLength > 1) {
                    order.colli = []

                    for (let index = 0; index < syncedColliLength; index++) {
                        order.colli.push({
                            description: order.content?.description || '',
                            weight: order.content?.weight || 0,
                            length: order.content?.length || 0,
                            width: order.content?.width || 0,
                            height: order.content?.height || 0,
                            barcode: resolveBarcode(barcodes[index]),
                            type: resolveColliType(colliTypes[colliTypes.length > 1 ? index : 0] || '')
                        })
                    }
                } else {
                    order.colli = [{
                        description: order.content?.description || '',
                        weight: order.content?.weight || 0,
                        length: order.content?.length || 0,
                        width: order.content?.width || 0,
                        height: order.content?.height || 0,
                        barcode: resolveBarcode(barcodes[0]),
                        type: resolveColliType(colliTypes[0] || '')
                    }]

                    const quantity = order.content?.quantity || 1

                    if (quantity > 1) {
                        for (let i = 1; i < quantity; i++) {
                            order.colli.push({
                                type: resolveColliType(colliTypes[colliTypes.length > 1 ? i : 0] || ''),
                                description: '',
                                weight: 0,
                                length: 0,
                                width: 0,
                                height: 0,
                                barcode: resolveBarcode('')
                            })
                        }
                    }
                }
            }

            if (!order.customer) {
                this.setState({progressNow: this.state.progressNow + 1})
                errors.push(t('importLine', {line: index + 1, message: t('importCustomerNotFound', {customer: order.customerId})}))
                errorLines.push(`${line.join(';')};${t('importCustomerNotFound', {customer: order.customerId})}`)
                next()
            } else {
                if (orderType !== 'multiOrder') {
                    OrderActions.create(order, {fromImport: true, routeName}, (err, createdOrder, warning) => {
                        this.setState({progressNow: this.state.progressNow + 1})

                        if (err) {
                            errors.push(t('importLine', {line: index + 1, message: err}))
                            errorLines.push(`${line.join(';')};${err.replace(/"/g, '')}`)
                        } else {
                            success += 1

                            // The order exists, so it isn't added to the error lines: importing it again would duplicate it
                            if (warning) {
                                errors.push(t('importLine', {line: index + 1, message: warning}))
                            }
                        }

                        next()
                    })
                } else {
                    next()
                }
            }
        }, () => {
            if (orderType === 'multiOrder') {
                if (this.state.stopOperation) return
                OrderActions.create(order, {fromImport: true, routeName}, (err, createdOrder, warning) => {
                    this.setState({progressNow: this.state.stopOperation ? this.state.progressMax : 1})

                    let message

                    if (err) {
                        errors.push(`${err}`)
                        errorLines.push(`${err.replace(/"/g, '')}`)
                    } else {
                        success += 1
                        message = t('importOrdersCreated', {count: success})

                        if (warning) {
                            errors.push(t('importLine', {line: routeNameIndex + 1, message: warning}))
                        }
                    }
                    console.log(errors)
                    this.setState({loading: false, message, errors, errorLines})
                })
            } else {
                const message = t('importOrdersCreated', {count: success})
                this.setState({loading: false, message, errors, errorLines})
            }
        })

        if (user.isCustomer) {
            user.settings.orders.csvColumns = columns
            LoginActions.updateUserSettings(user)
        } else if (customer) {
            LoginActions.updateCsvColumns('orders', customer._id, [...columns], undefined, orderType, (err) => {
                this.setState({csvColumnsError: err ? t('importCsvColumnsNotSaved', {error: err}) : ''})
            })
        }
    }

    onClickDownloadErrors() {
        const {errorLines} = this.state
        const blob = new Blob([errorLines.join('\n')], {type: 'data:text/csv,charset=utf-8'})
        FileSaver.saveAs(blob, 'foutieve_ritten.csv')
    }

    render() {
        const {modalIsOpen, customerId, contact, email, phone, startTime, endTime, priceTableId, feeIds, price, pickupOptions, deliveryOptions, orderType, ignoreFirstLine, addColloWithBarcode, useAddressBook, columns, lines, customerInvalid, loading, progressNow, progressMax, message, csvColumnsError, errors, errorLines} = this.state
        const {reseller, user, customers} = this.props

        const customer = customers?.[customerId]
        const priceTable = _.find(reseller.settings.orders.prices, {id: priceTableId})

        return (
            <Modal
                style={{width: 'auto', minWidth: 800, maxWidth: '90vw'}}
                closeButton
                title='Ritten importeren'
                show={modalIsOpen}
                onClose={this.close.bind(this)}
            >

                {!user.isCustomer && !progressMax &&
                    <>
                        <H5 style={{marginBottom: 24}}>Klantgegevens</H5>

                        <FormStack style={{width: 788, marginBottom: formSpacing.rowGap}}>
                            <FormRow>
                                <FormRow style={{flex: 1}}>
                                    <Select
                                        openAfter={1}
                                        label='Klant'
                                        options={_.values(customers).filter((customer) => !customer.isArchived).map((customer) => ({value: customer._id, title: customer.name}))}
                                        value={customerId}
                                        isInvalid={customerInvalid}
                                        onChange={this.onChangeCustomer.bind(this)}
                                        ref={(ref) => this.selectCustomer = ref}
                                    />

                                    <Input
                                        id='contact'
                                        label='Contactpersoon'
                                        suggestions={customer ? customer.contacts?.map((contact) => contact.name) : []}
                                        suggestionFilter
                                        value={contact}
                                        onChange={this.onChangeContact.bind(this)}
                                    />
                                </FormRow>

                                <DatePicker
                                    label='Datum'
                                    value={this.state.date}
                                    onChange={(event) => this.setState({date: event.target.value})}
                                />
                            </FormRow>

                            <FormRow>
                                <FormRow style={{flex: 1}}>
                                    <Input
                                        type='email '
                                        label='Emailadres'
                                        value={email}
                                        onChange={(event) => this.setState({email: event.target.value})}
                                    />

                                    <Input
                                        type='phone'
                                        label='Telefoon'
                                        value={phone}
                                        onChange={(event) => this.setState({phone: event.target.value})}
                                    />
                                </FormRow>

                                <TextArea
                                    label='Opmerkingen'
                                    value={this.state.notes}
                                    onChange={(event) => this.setState({notes: event.target.value})}
                                />
                            </FormRow>
                        </FormStack>
                    </>
                }

                { !progressMax &&
                    <>
                        <H5 style={{marginBottom: 24, marginTop: 36}}>Adressen</H5>

                        <FormStack style={{width: 788, marginBottom: formSpacing.rowGap}}>
                            <FormRow>
                                <Select
                                    label={t('importOrderType')}
                                    value={orderType}
                                    onChange={this.onChangeOrderType.bind(this)}
                                >
                                    <option value='delivery'>{t('importOrderTypeDelivery')}</option>
                                    <option value='pickup'>{t('importOrderTypePickup')}</option>
                                    <option value='pickupDelivery'>{t('importOrderTypePickupDelivery')}</option>
                                    <option value='multiOrder'>{t('importOrderTypeMultiOrder')}</option>
                                </Select>

                                <FormRow style={{flex: 1}}>
                                    <TimePicker
                                        label='Starttijd'
                                        value={startTime}
                                        onChange={(event) => this.setState({startTime: event.target.value})}
                                    />
                                    <TimePicker
                                        label='Eindtijd'
                                        value={endTime}
                                        onChange={(event) => this.setState({endTime: event.target.value})}
                                    />
                                </FormRow>
                            </FormRow>

                            <FormRow>
                                <Select
                                    label='Ophaalopties'
                                    values={pickupOptions}
                                    disabled={orderType === 'delivery'}
                                    options={[
                                        ...Object.entries(dbCodes.pickupOptions).map(([value, title]) => ({value, title})),
                                        ...(reseller.settings.orders.customOptions || []).map((option) => ({
                                            value: option.id,
                                            title: option.name,
                                            icon: 'mdi mdi-circle',
                                            iconColor: option.color,
                                            showIconInValue: true
                                        }))
                                    ]}
                                    onChange={(event) => this.setState({pickupOptions: event.target.values})}
                                />

                                <Select
                                    label='Bezorgopties'
                                    values={deliveryOptions}
                                    disabled={orderType === 'pickup'}
                                    options={[
                                        ...Object.entries(dbCodes.pickupAndDeliveryOptions).map(([value, title]) => ({value, title})),
                                        ...(reseller.settings.orders.customOptions || []).map((option) => ({
                                            value: option.id,
                                            title: option.name,
                                            icon: 'mdi mdi-circle',
                                            iconColor: option.color,
                                            showIconInValue: true
                                        }))
                                    ]}
                                    onChange={(event) => this.setState({deliveryOptions: event.target.values})}
                                />
                            </FormRow>

                            <FormRow>
                                <Toggle
                                    label='Collo met barcode toevoegen aan adressen'
                                    checked={addColloWithBarcode}
                                    onChange={(event) => this.setState({addColloWithBarcode: event.target.checked})}
                                />
                                <div style={{flex: 1}} />
                            </FormRow>

                            <FormRow>
                                <Toggle
                                    label='Negeer 1e regel van CSV bestand'
                                    checked={ignoreFirstLine}
                                    onChange={(event) => this.setState({ignoreFirstLine: event.target.checked})}
                                />
                                <div style={{flex: 1}} />
                            </FormRow>

                            <FormRow>
                                <Toggle
                                    label='Corrigeer adressen vanuit adresboek'
                                    info='Als de adresnaam voorkomt in het adresboek, wordt het volledige adres uit het adresboek gebruikt in plaats van de gegevens uit het CSV bestand.'
                                    checked={useAddressBook}
                                    onChange={(event) => this.setState({useAddressBook: event.target.checked})}
                                />
                                <div style={{flex: 1}} />
                            </FormRow>
                        </FormStack>

                        {!!lines.length && !progressMax &&
                            <>
                                <div style={{minHeight: 500, maxHeight: 500, overflow: 'auto'}}>
                                    <Row style={{flexShrink: 0, width: 'max-content', columnGap: formSpacing.columnGap, marginBottom: 12}}>
                                        {columns.map((value, index) => {
                                            const possibleColumnsWithAddresses = user.isCustomer ? _.omit(possibleColumns, 'routeName') : {...possibleColumns}

                                            if (orderType === 'pickup' || orderType === 'pickupDelivery') {
                                                possibleColumnsWithAddresses['addresses.0.name'] = 'Ophaaladres: Naam'
                                                possibleColumnsWithAddresses['addresses.0.attention'] = 'Ophaaladres: T.a.v.'
                                                possibleColumnsWithAddresses['addresses.0.street'] = 'Ophaaladres: Straat'
                                                possibleColumnsWithAddresses['addresses.0.nr'] = 'Ophaaladres: Huisnummer'
                                                possibleColumnsWithAddresses['addresses.0.addition'] = 'Ophaaladres: Toevoeging'
                                                possibleColumnsWithAddresses['addresses.0.streetNr'] = 'Ophaaladres: Straat + Huisnummer + toevoeging'
                                                possibleColumnsWithAddresses['addresses.0.nrAddition'] = 'Ophaaladres: Huisnummer + toevoeging'
                                                possibleColumnsWithAddresses['addresses.0.street2'] = 'Ophaaladres: 2e adres regel'
                                                possibleColumnsWithAddresses['addresses.0.postalCode'] = 'Ophaaladres: Postcode'
                                                possibleColumnsWithAddresses['addresses.0.city'] = 'Ophaaladres: Plaats'
                                                possibleColumnsWithAddresses['addresses.0.country'] = 'Ophaaladres: Landcode'
                                                possibleColumnsWithAddresses['addresses.0.position'] = 'Ophaaladres: Coördinaten'
                                                possibleColumnsWithAddresses['addresses.0.lat'] = 'Ophaaladres: Latitude'
                                                possibleColumnsWithAddresses['addresses.0.lng'] = 'Ophaaladres: Longitude'
                                                possibleColumnsWithAddresses['addresses.0.startTime'] = 'Ophaaladres: Starttijd'
                                                possibleColumnsWithAddresses['addresses.0.endTime'] = 'Ophaaladres: Eindtijd'
                                                possibleColumnsWithAddresses['addresses.0.instructions'] = 'Ophaaladres: Instructies'
                                                possibleColumnsWithAddresses['addresses.0.email'] = 'Ophaaladres: Emailadres'
                                                possibleColumnsWithAddresses['addresses.0.phone'] = 'Ophaaladres: Telefoon'
                                                possibleColumnsWithAddresses['addresses.0.customOptions'] = 'Ophaaladres: Eigen opties'
                                            }

                                            if (orderType === 'delivery' || orderType === 'pickupDelivery') {
                                                possibleColumnsWithAddresses['addresses.1.name'] = 'Bezorgadres: Naam'
                                                possibleColumnsWithAddresses['addresses.1.attention'] = 'Bezorgadres: T.a.v.'
                                                possibleColumnsWithAddresses['addresses.1.street'] = 'Bezorgadres: Straat'
                                                possibleColumnsWithAddresses['addresses.1.nr'] = 'Bezorgadres: Huisnummer'
                                                possibleColumnsWithAddresses['addresses.1.addition'] = 'Bezorgadres: Toevoeging'
                                                possibleColumnsWithAddresses['addresses.1.streetNr'] = 'Bezorgadres: Straat + Huisnummer + toevoeging'
                                                possibleColumnsWithAddresses['addresses.1.nrAddition'] = 'Bezorgadres: Huisnummer + toevoeging'
                                                possibleColumnsWithAddresses['addresses.1.street2'] = 'Bezorgadres: 2e adres regel'
                                                possibleColumnsWithAddresses['addresses.1.postalCode'] = 'Bezorgadres: Postcode'
                                                possibleColumnsWithAddresses['addresses.1.city'] = 'Bezorgadres: Plaats'
                                                possibleColumnsWithAddresses['addresses.1.country'] = 'Bezorgadres: Landcode'
                                                possibleColumnsWithAddresses['addresses.1.position'] = 'Bezorgadres: Coördinaten'
                                                possibleColumnsWithAddresses['addresses.1.lat'] = 'Bezorgadres: Latitude'
                                                possibleColumnsWithAddresses['addresses.1.lng'] = 'Bezorgadres: Longitude'
                                                possibleColumnsWithAddresses['addresses.1.startTime'] = 'Bezorgadres: Starttijd'
                                                possibleColumnsWithAddresses['addresses.1.endTime'] = 'Bezorgadres: Eindtijd'
                                                possibleColumnsWithAddresses['addresses.1.instructions'] = 'Bezorgadres: Instructies'
                                                possibleColumnsWithAddresses['addresses.1.email'] = 'Bezorgadres: Emailadres'
                                                possibleColumnsWithAddresses['addresses.1.phone'] = 'Bezorgadres: Telefoon'
                                                possibleColumnsWithAddresses['addresses.1.signatureRequired'] = 'Bezorgadres: Handtekening'
                                                possibleColumnsWithAddresses['addresses.1.statedAddressOnly'] = 'Bezorgadres: Niet bij buren'
                                                possibleColumnsWithAddresses['addresses.1.mailboxDelivery'] = 'Bezorgadres: Brievenbuspakket'
                                                possibleColumnsWithAddresses['addresses.1.refrigerated'] = 'Bezorgadres: Gekoeld'
                                                possibleColumnsWithAddresses['addresses.1.customOptions'] = 'Bezorgadres: Eigen opties'
                                            }

                                            if (orderType === 'multiOrder') {
                                                possibleColumnsWithAddresses['addresses.1.name'] = 'Naam'
                                                possibleColumnsWithAddresses['addresses.1.attention'] = 'T.a.v.'
                                                possibleColumnsWithAddresses['addresses.1.street'] = 'Straat'
                                                possibleColumnsWithAddresses['addresses.1.nr'] = 'Huisnummer'
                                                possibleColumnsWithAddresses['addresses.1.addition'] = 'Toevoeging'
                                                possibleColumnsWithAddresses['addresses.1.streetNr'] = 'Straat + Huisnummer + toevoeging'
                                                possibleColumnsWithAddresses['addresses.1.nrAddition'] = 'Huisnummer + toevoeging'
                                                possibleColumnsWithAddresses['addresses.1.street2'] = '2e adres regel'
                                                possibleColumnsWithAddresses['addresses.1.postalCode'] = 'Postcode'
                                                possibleColumnsWithAddresses['addresses.1.city'] = 'Plaats'
                                                possibleColumnsWithAddresses['addresses.1.country'] = 'Landcode'
                                                possibleColumnsWithAddresses['addresses.1.startTime'] = 'Starttijd'
                                                possibleColumnsWithAddresses['addresses.1.endTime'] = 'Eindtijd'
                                                possibleColumnsWithAddresses['addresses.1.instructions'] = 'Instructies'
                                                possibleColumnsWithAddresses['addresses.1.email'] = 'Emailadres'
                                                possibleColumnsWithAddresses['addresses.1.phone'] = 'Telefoon'
                                                possibleColumnsWithAddresses['addresses.1.customOptions'] = 'Eigen opties'
                                                possibleColumnsWithAddresses['addresses.1.addressTypeDelivery'] = 'Type adres: Bezorgadres'
                                                possibleColumnsWithAddresses['addresses.1.addressTypePickup'] = 'Type adres: Ophaaladres'
                                            }

                                            return (
                                                <Select
                                                    key={index}
                                                    style={{width: 200}}
                                                    allowEmpty
                                                    placeholder='Negeer kolom'
                                                    value={value}
                                                    onChange={this.onChangeColumn.bind(this, index)}
                                                >
                                                    {_.keys(possibleColumnsWithAddresses).map((key) => {
                                                        return <option key={key} value={key}>{possibleColumnsWithAddresses[key]}</option>
                                                    })}
                                                </Select>
                                            )
                                        })}
                                    </Row>

                                    {lines.map((line, index) => {
                                        if ((index > 0 || !ignoreFirstLine) && index < 20) {
                                            return (
                                                <Row
                                                    key={index}
                                                    style={{
                                                        flexShrink: 0,
                                                        width: 'max-content',
                                                        paddingTop: 6,
                                                        paddingBottom: 6,
                                                        background: 'white',
                                                        borderBottom: '1px solid',
                                                        borderColor: Colors.grey40
                                                    }}
                                                >
                                                    {line.map((value, index) => {
                                                        return (
                                                            <Row
                                                                key={index}
                                                                style={{paddingLeft: 6, paddingRight: 6,
                                                                    width: 212,
                                                                    flexShrink: 0, minWidth: 'auto'
                                                                }}
                                                            >
                                                                <P ellipsis>{value}</P>
                                                            </Row>
                                                        )
                                                    })}
                                                </Row>
                                            )
                                        }
                                    })}
                                </div>
                            </>
                        }

                        {!!lines.length && !progressMax &&
                            <Row style={{justifyContent: 'flex-end', marginTop: 6}}>
                                <S2>{`${ignoreFirstLine ? lines.length - 1 : lines.length} regels`}</S2>
                            </Row>
                        }

                        {!progressMax &&
                            <Button
                                style={{marginTop: 12}}
                                variant='outline-white'
                                label='Selecteer CSV bestand'
                                icon='mdi mdi-folder-open'
                                onClick={this.onClickOpenFile.bind(this)}
                            />
                        }

                        <H5
                            style={{cursor: 'pointer', marginTop: 36, marginBottom: 12}}
                            onClick={() => this.setState({showAdministration: !this.state.showAdministration})}
                        >
                            Administratie
                            <i className={this.state.showAdministration ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'} />
                        </H5>

                        {this.state.showAdministration &&
                            <>

                                <FormStack style={{width: 788, marginBottom: formSpacing.rowGap}}>
                                    <FormRow>
                                        <FormRow style={{flex: 1}}>
                                            <Select
                                                label={t('priceTable')}
                                                allowEmpty
                                                value={priceTableId}
                                                onChange={this.onChangePricetableId.bind(this)}

                                            >
                                                {naturalSortBy(reseller.settings.orders.prices || [], 'name').map((priceTable) => {
                                                    return (
                                                        <option key={priceTable.id} value={priceTable.id}>{priceTable.name}</option>
                                                    )
                                                })}
                                            </Select>

                                            <Select
                                                style={{flex: 1}}
                                                label='Toeslag'
                                                values={feeIds}
                                                options={(priceTable?.fees || []).filter((fee) => !fee.auto).map((fee) => {
                                                    return {value: fee.id, title: fee.description}
                                                })}
                                                onChange={(event) => this.setState({feeIds: event.target.values})}
                                                disabled={!priceTableId || !priceTable}
                                            />
                                        </FormRow>

                                        <CurrencyInput
                                            label='Prijs'
                                            value={price}
                                            onChange={(event) => this.setState({price: event.target.value})}
                                            disabled={priceTableId}
                                        />
                                    </FormRow>

                                    <FormRow>
                                        <Input
                                            label='Referentie'
                                            value={this.state.reference}
                                            onChange={(event) => this.setState({reference: event.target.value})}
                                        />
                                        <div style={{flex: 1}} />
                                    </FormRow>
                                </FormStack>
                            </>
                        }

                        <H5
                            style={{cursor: 'pointer', marginTop: 36, marginBottom: 12}}
                            onClick={() => this.setState({showOtherOptions: !this.state.showOtherOptions})}
                        >
                            Overige opties
                            <i className={this.state.showOtherOptions ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'} />
                        </H5>

                        {this.state.showOtherOptions && !reseller.isShop &&
                            <FormStack style={{width: 788, marginBottom: this.state.autoRetour ? 0 : 12}}>
                                {!reseller.isShop &&
                                    <FormRow>
                                        <Input
                                            label='Aantal bezorgpogingen'
                                            info='Ritten worden automatisch verplaatst naar de volgende werkdag na een mislukte bezorgpoging tot het maximaal aantal bezorgpogingen is bereikt. Vul 0 in om ritten nooit automatisch te verplaatsen.'
                                            type='number'
                                            min={0}
                                            value={this.state.nrOfDeliveries}
                                            onChange={(event) => this.setState({nrOfDeliveries: parseInt(event.target.value)})}
                                        />

                                        <Toggle
                                            label='Automatisch retour'
                                            checked={this.state.autoRetour}
                                            onChange={(event) => this.setState({autoRetour: event.target.checked})}
                                        />
                                    </FormRow>
                                }

                                {this.state.autoRetour && this.state.nrOfDeliveries > 0 &&
                                    <FormRow>
                                        <Input
                                            label='Bewaartijd'
                                            info='Hoeveel dagen blijft de rit in bewaring na de laatste bezorgpoging. Vul 0 in om na de laatste bezorgpoging meteen een retourrit aan te maken.'
                                            type='number'
                                            value={this.state.nrOfDaysBeforeRetour}
                                            onChange={(event) => this.setState({nrOfDaysBeforeRetour: parseInt(event.target.value)})}
                                        />
                                        <div style={{flex: 1}} />
                                    </FormRow>
                                }

                                {this.state.autoRetour &&
                                    <div>
                                        <H6 style={{marginBottom: 12}}>Retouradres</H6>

                                        <Card style={{width: '100%', background: Colors.grey20, padding: formSpacing.inset}}>
                                            <EditAddress
                                                id='address-retour'
                                                address={this.state.retourAddress}
                                                onChange={(address) => this.setState({retourAddress: address})}
                                                allowAttachments={true}
                                                ref={(ref) => this.retourAddress = ref}
                                            />
                                        </Card>

                                    </div>
                                }
                            </FormStack>
                        }
                    </>
                }

                <br />
                <br />
                {progressMax &&
                    <ProgressBar style={{marginBottom: 16}} now={progressNow} max={progressMax} />
                }

                {message &&
                    <Alert style={{marginBottom: 6}} variant='success'>{message}</Alert>
                }

                {csvColumnsError &&
                    <Alert style={{marginBottom: 6}} variant='warning'>{csvColumnsError}</Alert>
                }

                {errors.length > 0 &&
                    <div style={{maxHeight: 300, overflow: 'auto'}}>
                        {errors.map((error, index) => {
                            return <Alert style={{marginBottom: 6}} key={`error${index}`} variant='danger'>{error}</Alert>
                        })}
                    </div>

                }

                <br />

                <div style={{display: 'flex', justifyContent: 'flex-end', columnGap: formSpacing.columnGap}}>
                    {!!errorLines.length &&
                        <Link
                            onClick={this.onClickDownloadErrors.bind(this)}
                        >
                            Download foutieve ritten .csv
                        </Link>
                    }

                    {loading &&
                        <Button
                            variant='outline-white'
                            onClick={() => this.setState({stopOperation: true, loading: false, progressNow: progressMax})}
                        >
                            Afbreken
                        </Button>
                    }

                    {progressMax && progressNow >= progressMax ?
                        <Button
                            onClick={this.close.bind(this)}
                        >
                            Sluiten
                        </Button> :
                        <Button
                            loading={loading}
                            disabled={!lines.length}
                            onClick={() => this.setState({stopOperation: false}, this.onClickCreateOrders)}
                        >
                            Importeer
                        </Button>
                    }
                </div>

                <input
                    type='file'
                    id='csv'
                    accept='.csv'
                    style={{visibility: 'hidden', height: 0}}
                    onChange={this.onLoadFile.bind(this)}
                />
            </Modal>

        )
    }
}

// TODO specify type of column (text, number, date, etc) and use it to validate and parse input
const possibleColumns = {
    'customer': t('customer'),
    'debtorCode': t('importColumnDebtorCode'),
    'date': t('date'),
    'price': t('price'),
    'reference': t('reference'),
    'routeName': t('route'),
    'barcode': t('importColumnBarcode'),
    'colliType': t('importColumnColliType'),
    'notes': t('importColumnNotes'),
    'nrOfDeliveries': t('importColumnNrOfDeliveries'),
    'content.quantity': t('importColumnQuantity'),
    'content.description': t('importColumnDescription'),
    'content.weight': t('importColumnWeight'),
    'content.length': t('importColumnLength'),
    'content.width': t('importColumnWidth'),
    'content.height': t('importColumnHeight')
}
